import { render } from "./TarifasView.vue?vue&type=template&id=9610013c"
import script from "./TarifasView.vue?vue&type=script&lang=js"
export * from "./TarifasView.vue?vue&type=script&lang=js"

import "./TarifasView.vue?vue&type=style&index=0&id=9610013c&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__